import { COLORS } from './colors';

// Component-specific color configurations
export const COMPONENT_COLORS = {
  // Header colors
  HEADER: {
    DEFAULT_FONT: COLORS.OFF_WHITE,
    DEFAULT_BACKGROUND: COLORS.BACKGROUND,
  },
  // Store map colors
  STORE_MAP: {
    MARKER: COLORS.OFF_WHITE,
  },
  // Common text colors
  TEXT: {
    DARK: COLORS.TEXT_DARK,
    LIGHT: COLORS.OFF_WHITE,
  },
} as const; 